module.exports = __webpack_public_path__ + "static/media/hide.827e7ae8.svg";